import { useEffect } from 'react'


/* Кнопка чата CarrotQuest висит в правом нижнем углу поверх контента. На шахматке она
   перекрывает плашки броней последних строк, поэтому на таких страницах чат прячем.
   Виджет живёт вне React (скрипт вставляет его в body), убрать его можно только стилями —
   правило лежит в globalStyles и включается этим классом. */
export const HIDE_CHAT_CLASS = 'knm-hide-chat'

export const useHideChat = (): void => {
  useEffect(() => {
    document.body.classList.add(HIDE_CHAT_CLASS)

    return () => document.body.classList.remove(HIDE_CHAT_CLASS)
  }, [])
}
